import { render, staticRenderFns } from "./PolymorphicReferenceCreateScreen.vue?vue&type=template&id=53f24e55&"
import script from "./PolymorphicReferenceCreateScreen.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports